/* MyPetClub Futterfinder
 * Rasse + Hundedaten -> Tagesbedarf (kcal) -> Sorten nach Wünschen/Ausschlüssen filtern und nach Bedarf sortieren -> Menge, Kosten.
 * Rassen: Metaobjekt "hunderasse", per ?view=rassen-daten erst bei Interaktion geladen.
 * Sorten: Produkt-Metafeld custom.futter_check (kcal, Proteine, Eigenschaften), Zutaten und Rohnährstoffe aus den Produktdaten.
 * Rechenlogik wie in den Futtermenge-Artikeln:
 *   Erwachsene: 70 x kg^0,75 x 1,4 / 1,6 / 2,0, kastriert minus 10 %
 *   Senioren:   70 x kg^0,75 x 1,6 x 0,85, kastriert minus 10 %
 *   Welpen:     130 x kg^0,75 x 3,2 x (e^(-0,87 x p) - 0,1), p = aktuelles / erwartetes Endgewicht
 */
(function () {
  'use strict';

  /* ===== RECHNEN ===== */
  var ACT = { low: 1.4, mid: 1.6, high: 2.0 };
  function rer(w) { return 70 * Math.pow(w, 0.75); }
  function dailyKcal(a) {
    var w = a.weight;
    if (a.age === 'puppy') {
      var p = Math.min(1, Math.max(0.05, w / a.finalWeight));
      return 130 * Math.pow(w, 0.75) * 3.2 * (Math.exp(-0.87 * p) - 0.1);
    }
    var f = a.age === 'senior' ? ACT.mid * 0.85 : ACT[a.activity];
    if (a.shape === 'lean') f += 0.2;
    if (a.shape === 'heavy') f -= 0.3;
    f = Math.min(3.0, Math.max(1.0, f));
    return rer(w) * f * (a.neutered ? 0.9 : 1);
  }
  function gramsPerDay(kcal, kcalPerKg) { return Math.round(kcal / kcalPerKg * 1000); }
  function mealCount(a) {
    if (a.age !== 'puppy') return 2;
    var p = a.weight / a.finalWeight;
    return p <= 0.5 ? 4 : (p <= 0.9 ? 3 : 2);
  }
  function bagKg(v) {
    var kg = v.g / 1000;
    if (!(kg > 0)) {
      var m = String(v.t).replace(',', '.').match(/([\d.]+)\s*kg/i);
      kg = m ? parseFloat(m[1]) : 0;
    }
    return kg;
  }
  function bigBag(vars) {
    var best = null;
    (vars || []).forEach(function (v) {
      var kg = bagKg(v);
      if (kg > 0 && (!best || kg > best.kg)) best = { kg: kg, price: v.p };
    });
    return best;
  }
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/ı/g, 'i').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '');
  }
  function meanWeight(b) {
    var a = b.gmin, c = b.gmax;
    if (a == null && c == null) return '';
    if (a == null) return c;
    if (c == null) return a;
    return Math.round((a + c) / 2 * 2) / 2;
  }

  /* ===== FILTERN UND SORTIEREN ===== */
  var EX = [['getreide', 'Getreide'], ['reis', 'Reis'], ['mais', 'Mais'], ['kartoffel', 'Kartoffel'], ['erbsen', 'Erbsen'], ['ei', 'Ei'],
    ['gefluegel', 'Geflügel'], ['rind', 'Rind'], ['lamm', 'Lamm'], ['fisch', 'Fisch'], ['insekt', 'Insekten'], ['hirsch', 'Hirsch']];
  var WISH = [['single', 'Nur ein Protein'], ['cold', 'Kaltgepresst'], ['vegan', 'Fleischfrei'], ['high', 'Proteinreich'], ['purin', 'Purinarm'], ['sensitiv', 'Empfindlicher Magen']];
  var LABEL = {}; EX.forEach(function (e) { LABEL[e[0]] = e[1]; });
  var PROT = { gefluegel: 1, rind: 1, lamm: 1, fisch: 1, insekt: 1, hirsch: 1 };
  var NOVEL = { hirsch: 1, insekt: 1, lamm: 1 };
  var RX = {
    reis: /reis/, mais: /(^|\s)mais/, kartoffel: /(^|\s)kartoffel/, erbsen: /erbse/, ei: /^ei$/,
    gefluegel: /gefl|huhn|(^|\s)pute|(^|\s)ente|poulet/, rind: /(^|\s)rind/, lamm: /lamm/, fisch: /lachs|forelle|fisch/, insekt: /insekt/, hirsch: /hirsch/
  };
  function ingHit(ing, key) {
    if (!ing || !RX[key]) return null;
    for (var i = 0; i < ing.length; i++) if (RX[key].test(String(ing[i]).toLowerCase())) return ing[i];
    return null;
  }
  function checkEx(r, key) {
    if (key === 'getreide') {
      if (r.grainFree === false) return { hard: true, why: 'enthält Getreide' };
      if (r.grainFree === null) return { note: 'Zutatenliste auf Getreide prüfen' };
      return null;
    }
    var hit = ingHit(r.ing, key);
    if (PROT[key]) {
      if (r.proteins && r.proteins.indexOf(key) >= 0) return { hard: true, why: 'enthält ' + LABEL[key] };
      if (r.proteins === null) return hit ? { hard: true, why: 'enthält ' + hit } : { note: 'Zutatenliste auf ' + LABEL[key] + ' prüfen' };
      return hit ? { note: 'enthält ' + hit + ' (nur als Zusatz)' } : null;
    }
    if (hit) return { hard: true, why: 'enthält ' + hit };
    if (!r.ing) return { note: 'Zutatenliste auf ' + LABEL[key] + ' prüfen' };
    return null;
  }
  function checkWish(r, k) {
    if (k === 'single') return r.single ? null : 'nicht nur ein Protein';
    if (k === 'cold') return r.cold ? null : 'nicht kaltgepresst';
    if (k === 'vegan') return r.vegan ? null : 'nicht fleischfrei';
    if (k === 'high') return r.high ? null : 'nicht proteinreich';
    if (k === 'purin') return r.purin ? null : 'nicht purinarm';
    return null;
  }
  function needLevel(a) {
    if (a.age === 'puppy') return 'high';
    if (a.activity === 'high' || a.shape === 'lean') return a.age === 'senior' ? 'mid' : 'high';
    if (a.age === 'senior' || a.activity === 'low' || a.shape === 'heavy') return 'low';
    return 'mid';
  }
  /* a: { age, activity, shape, ex[], wish[], allStages }, breed: { fu, allergiker, name } | null */
  function rank(recipes, a, breed) {
    var ok = [], out = [], need = needLevel(a);
    var sens = a.wish.indexOf('sensitiv') >= 0 || !!(breed && breed.allergiker >= 2);
    var f = norm(breed && breed.fu);
    recipes.forEach(function (r) {
      var stageOk = r.stages.indexOf(a.age) >= 0 || (a.age === 'puppy' && a.allStages && r.stages.indexOf('adult') >= 0);
      if (!stageOk) return;
      var reasons = [], why = [], warn = [], s = 50, i;
      a.ex.forEach(function (k) {
        var c = checkEx(r, k);
        if (c && c.hard) reasons.push(c.why); else if (c && c.note) warn.push(c.note);
      });
      a.wish.forEach(function (k) { var w = checkWish(r, k); if (w) reasons.push(w); });
      if (reasons.length) { out.push({ r: r, reasons: reasons }); return; }
      if (a.age === 'puppy') why.push('Für Welpen und Junghunde');
      if (a.ex.length) why.push('Ohne ' + a.ex.map(function (k) { return LABEL[k]; }).join(', '));
      a.wish.forEach(function (k) { for (i = 0; i < WISH.length; i++) if (WISH[i][0] === k && k !== 'sensitiv') why.push(WISH[i][1]); });
      if (f && (norm(r.name) === f || r.key.indexOf(ALIAS[f] || '@@') === 0)) { s += 15; why.push('Empfehlung für ' + breed.name); }
      if (sens) {
        if (r.single) { s += 20; why.push('Ein Protein, übersichtliche Zutaten'); }
        var nov = false; (r.proteins || []).forEach(function (p) { if (NOVEL[p]) nov = true; });
        if (nov) s += 10;
      }
      if (a.age === 'puppy' && r.stages.indexOf('puppy') >= 0) s += 40;
      if (a.wish.indexOf('purin') < 0 && r.purin) s -= 15;
      var dk = (r.kcal - 3500) / 20;
      if (need === 'high') {
        s += dk; if (r.high) s += 10;
        if (r.kcal >= 3790 && a.age !== 'puppy') why.push('Energiedicht für aktive Hunde');
      } else if (need === 'low') {
        s -= dk;
        if (r.fat != null) {
          if (r.fat > 15) s -= 8;
          if (r.fat <= 11.5) { s += 6; why.push('Moderater Fettgehalt (' + String(r.fat).replace('.', ',') + ' %)'); }
        }
        if (r.fiber != null && r.fiber >= 4) s += 6;
      }
      ok.push({ r: r, score: s, why: why, warn: warn });
    });
    ok.sort(function (x, y) { return y.score - x.score || x.r.order - y.r.order; });
    return { ok: ok, out: out, need: need };
  }
  var ALIAS = { geflugelforellekaltgepresst: 'kaltgepresst-poulet' };

  function parseNut(t) {
    function g(re) { var m = String(t || '').match(re); return m ? parseFloat(m[1].replace(',', '.')) : null; }
    return { protein: g(/Rohprotein[:\s]*([\d.,]+)/i), fat: g(/Rohfett[:\s]*([\d.,]+)/i), fiber: g(/Rohfaser[:\s]*([\d.,]+)/i) };
  }
  function toRecipe(r) {
    var f = r.fc || {}, nut = parseNut(r.nut);
    return {
      key: r.id, url: r.url, price: r.price, image: r.image,
      name: f.name || r.id, line: f.line || '',
      proteins: Array.isArray(f.proteins) ? f.proteins : null,
      grainFree: typeof f.grain_free === 'boolean' ? f.grain_free : null,
      single: !!f.single, cold: !!f.cold, vegan: !!f.meatfree, high: nut.protein != null ? nut.protein >= 30 : !!f.high, purin: !!f.purin,
      ing: Array.isArray(r.ing) ? r.ing : null,
      protein: nut.protein, fat: nut.fat, fiber: nut.fiber,
      kcal: f.kcal > 0 ? f.kcal : 3700, est: !(f.kcal > 0),
      stages: Array.isArray(f.stages) ? f.stages : ['adult', 'senior'],
      order: typeof f.order === 'number' ? f.order : 999,
      bag: bigBag(r.variants)
    };
  }

  var API = { dailyKcal: dailyKcal, gramsPerDay: gramsPerDay, mealCount: mealCount, bigBag: bigBag, norm: norm, meanWeight: meanWeight, rank: rank, toRecipe: toRecipe, needLevel: needLevel };
  if (typeof module !== 'undefined' && module.exports) { module.exports = API; return; }

  var root = document.querySelector('.mpc-rr');
  if (!root) return;
  var app = root.querySelector('.mpc-rr__app');
  var dataEl = root.querySelector('script[data-mpc-rr-data]');
  if (!app || !dataEl) return;

  /* ===== DATEN ===== */
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { cfg = { recipes: [] }; }
  var RECIPES = (cfg.recipes || []).map(toRecipe).sort(function (a, b) { return a.order - b.order; });
  if (!RECIPES.length) return;

  var BREEDS = null, loading = null;
  function toBreed(r) {
    if (!r || !r[0] || !r[1]) return null;
    return { handle: r[0], name: r[1], gmin: r[2], gmax: r[3], bew: r[4], fu: r[5], url: r[6], foto: r[7], allergiker: r[8], n: norm(r[1]) };
  }
  function loadBreeds() {
    if (BREEDS) return Promise.resolve(BREEDS);
    if (loading) return loading;
    var base = root.getAttribute('data-url') || '';
    function page(u) {
      return fetch(u, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('http ' + res.status); return res.text(); })
        .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); });
    }
    function walk(u, acc, guard) {
      return page(u).then(function (d) {
        acc = acc.concat(d.b || []);
        return d.next && guard < 10 ? walk(d.next, acc, guard + 1) : acc;
      });
    }
    loading = walk(base, [], 0).then(function (all) {
      BREEDS = all.map(toBreed).filter(Boolean).sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); });
      return BREEDS;
    });
    loading.then(null, function () { loading = null; });
    return loading;
  }

  /* ===== ZUSTAND ===== */
  var S = { breed: null, age: 'adult', weight: '', finalWeight: '', neutered: true, activity: 'mid', shape: 'ideal', ex: [], wish: [], pick: null, allStages: false };
  (function () {
    function pre(attr, allowed) {
      return String(root.getAttribute(attr) || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(function (x, i, arr) { return x && allowed.indexOf(x) >= 0 && arr.indexOf(x) === i; });
    }
    S.ex = pre('data-pre-ex', EX.map(function (e) { return e[0]; }));
    S.wish = pre('data-pre-wish', WISH.map(function (e) { return e[0]; }));
  })();
  var AGE_LABEL = { puppy: 'Welpe', adult: 'erwachsen', senior: 'Senior' };

  /* ===== HELFER ===== */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function n(x, d) { return x.toLocaleString('de-DE', { maximumFractionDigits: d == null ? 0 : d }); }
  function eur(x) { return x.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function $(id) { return document.getElementById('rr-' + id); }
  function track(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {} }
  function opt(k, v, label, sub, on, cls) {
    return '<button type="button" class="rr-opt' + (cls ? ' ' + cls : '') + '" data-k="' + k + '" data-v="' + v + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</button>';
  }
  function recipeByKey(list, k) { for (var i = 0; i < list.length; i++) if (list[i].r.key === k) return list[i]; return null; }

  /* ===== AUFBAU ===== */
  function build() {
    app.innerHTML =
      '<div class="rr-card">' +
      '<div class="rr-step">1. Dein Hund</div>' +
      '<div class="rr-field"><label class="rr-l" for="rr-q">Welche Rasse hat dein Hund?</label>' +
      '<div class="rr-sb"><input id="rr-q" class="rr-in" type="text" autocomplete="off" placeholder="Rasse suchen, z. B. Labrador oder Zwergpinscher" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="rr-list">' +
      '<ul id="rr-list" class="rr-list" role="listbox" hidden></ul></div>' +
      '<button type="button" class="rr-link" data-act="mix">Mischling oder Rasse nicht dabei? Gewicht selbst eingeben</button></div>' +
      '<div id="rr-form" class="rr-form" hidden>' +
      '<div id="rr-chosen" class="rr-chosen"></div>' +
      '<fieldset class="rr-fs"><legend>Wie alt ist er?</legend><div class="rr-opts" id="rr-age"></div></fieldset>' +
      '<div class="rr-grid"><div class="rr-field"><label class="rr-l" for="rr-w" id="rr-wl">Gewicht in kg</label><input id="rr-w" class="rr-in" type="number" inputmode="decimal" min="1" max="100" step="0.5"></div>' +
      '<div class="rr-field" id="rr-fwrap" hidden><label class="rr-l" for="rr-fw">Erwartetes Endgewicht in kg</label><input id="rr-fw" class="rr-in" type="number" inputmode="decimal" min="1" max="100" step="0.5"></div></div>' +
      '<fieldset class="rr-fs" id="rr-nwrap"><legend>Kastriert?</legend><div class="rr-opts" id="rr-neut"></div></fieldset>' +
      '<fieldset class="rr-fs" id="rr-awrap"><legend>Wie aktiv ist er?</legend><div class="rr-opts" id="rr-act"></div></fieldset>' +
      '<fieldset class="rr-fs" id="rr-swrap"><legend>Wie ist seine Figur?</legend><div class="rr-opts" id="rr-shape"></div></fieldset>' +
      '<div id="rr-need" class="rr-need" hidden></div>' +
      '</div></div>' +
      '<div id="rr-wishes" class="rr-card" hidden>' +
      '<div class="rr-step">2. Was soll rein, was nicht?</div>' +
      '<fieldset class="rr-fs"><legend>Darauf soll dein Hund verzichten <span class="rr-hint-s">Mehrfachauswahl</span></legend><div class="rr-opts rr-chips" id="rr-ex"></div></fieldset>' +
      '<fieldset class="rr-fs"><legend>Das ist dir wichtig <span class="rr-hint-s">Optional</span></legend><div class="rr-opts rr-chips" id="rr-wish"></div></fieldset>' +
      '<p id="rr-stagebox" class="rr-note" hidden></p></div>' +
      '<div id="rr-out" class="rr-out" aria-live="polite"></div>';
  }
  function syncForm() {
    var b = S.breed;
    $('form').hidden = !b; $('wishes').hidden = !b;
    if (!b) return;
    var range = '';
    if (b.gmin != null && b.gmax != null) range = (b.gmin === b.gmax ? n(b.gmin, 1) : n(b.gmin, 1) + ' bis ' + n(b.gmax, 1)) + ' kg';
    var ch = '<b>' + esc(b.name) + '</b>';
    if (range) ch += '<span>Typisches Gewicht der Rasse: ' + range + '</span>';
    else if (b.handle) ch += '<span>Für diese Rasse fehlt noch eine Gewichtsangabe, bitte trag das Gewicht ein.</span>';
    if (b.bew >= 5 && S.age === 'adult') ch += '<span>Hoher Bewegungsbedarf: Bei Hundesport oder Arbeit wähle „Sehr aktiv“.</span>';
    if (b.allergiker >= 2) ch += '<span>Diese Rasse neigt häufiger zu Futterunverträglichkeiten. Wir bevorzugen Sorten mit nur einem Protein.</span>';
    var cb = $('chosen');
    cb.style.cssText = b.foto ? 'display:flex;align-items:center;gap:14px' : '';
    cb.innerHTML = '<div style="flex:1;min-width:0">' + ch + '</div>' + (b.foto ? '<img src="' + esc(b.foto) + '" alt="' + esc(b.name) + '" width="88" height="88" loading="lazy" style="flex:none;width:88px;height:88px;border-radius:12px;object-fit:cover;background:#f3f3ee" onerror="this.remove()">' : '');
    $('age').innerHTML = opt('age', 'puppy', 'Welpe / Junghund', 'bis ca. 12 Monate', S.age === 'puppy') + opt('age', 'adult', 'Erwachsen', '1 bis 7 Jahre', S.age === 'adult') + opt('age', 'senior', 'Senior', 'ab ca. 8 Jahren', S.age === 'senior');
    $('neut').innerHTML = opt('neutered', 'true', 'Ja', '', S.neutered) + opt('neutered', 'false', 'Nein', '', !S.neutered);
    $('act').innerHTML = opt('activity', 'low', 'Ruhig', 'Spaziergänge, viel Sofa', S.activity === 'low') + opt('activity', 'mid', 'Normal', 'Täglich 1 bis 2 Stunden', S.activity === 'mid') + opt('activity', 'high', 'Sehr aktiv', 'Sport, Joggen, Arbeitshund', S.activity === 'high');
    $('shape').innerHTML = opt('shape', 'lean', 'Eher schlank', '', S.shape === 'lean') + opt('shape', 'ideal', 'Ideal', 'Rippen fühlbar', S.shape === 'ideal') + opt('shape', 'heavy', 'Etwas zu viel', '', S.shape === 'heavy');
    $('wl').textContent = S.age === 'puppy' ? 'Aktuelles Gewicht in kg' : 'Gewicht in kg';
    $('fwrap').hidden = S.age !== 'puppy';
    $('nwrap').hidden = S.age === 'puppy';
    $('awrap').hidden = S.age !== 'adult';
    $('swrap').hidden = S.age === 'puppy';
    $('ex').innerHTML = EX.map(function (e) { return opt('ex', e[0], e[1], '', S.ex.indexOf(e[0]) >= 0, 'rr-chip'); }).join('');
    $('wish').innerHTML = WISH.map(function (e) { return opt('wish', e[0], e[1], '', S.wish.indexOf(e[0]) >= 0, 'rr-chip'); }).join('');
    var sb = $('stagebox');
    sb.hidden = S.age !== 'puppy';
    if (S.age === 'puppy') sb.innerHTML = 'Für Welpen zeigen wir unser Welpenfutter. <button type="button" class="rr-link" data-act="stages">' + (S.allStages ? 'Nur Welpenfutter zeigen' : 'Alle Sorten zeigen, z. B. beim Futterwechsel') + '</button>';
    if (document.activeElement !== $('w')) $('w').value = S.weight === '' ? '' : S.weight;
    if (document.activeElement !== $('fw')) $('fw').value = S.finalWeight === '' ? '' : S.finalWeight;
  }

  /* ===== ERGEBNIS ===== */
  var NEED_TXT = {
    high: 'Hoher Energiebedarf: Wir bevorzugen energiedichte, proteinreiche Sorten.',
    low: 'Eher geringer Energiebedarf: Wir bevorzugen Sorten mit weniger Energie und moderatem Fettgehalt.',
    mid: ''
  };
  function ring(p, size, cap) {
    var rad = size / 2 - 5, c = 2 * Math.PI * rad, col = p >= 80 ? 'var(--rr-brand)' : '#d39a1f', m = size / 2;
    return '<span class="rr-ringbox"><span class="rr-ring' + (size < 60 ? ' sm' : '') + '" role="img" aria-label="' + p + ' Prozent Übereinstimmung" style="width:' + size + 'px;height:' + size + 'px">' +
      '<svg viewBox="0 0 ' + size + ' ' + size + '" width="' + size + '" height="' + size + '" aria-hidden="true"><circle cx="' + m + '" cy="' + m + '" r="' + rad + '" fill="none" stroke="#e6e9dd" stroke-width="5"/>' +
      '<circle cx="' + m + '" cy="' + m + '" r="' + rad + '" fill="none" stroke="' + col + '" stroke-width="5" stroke-linecap="round" stroke-dasharray="' + (c * p / 100).toFixed(1) + ' ' + c.toFixed(1) + '" transform="rotate(-90 ' + m + ' ' + m + ')"/></svg><b>' + p + '%</b></span>' + (cap ? '<span>' + cap + '</span>' : '') + '</span>';
  }
  function pct(list, x) {
    var base = 99 - Math.min(9, list[0].warn.length * 3);
    return Math.max(55, Math.min(base, Math.round(base - (list[0].score - x.score) * 1.2)));
  }
  function stats(r, g, puppy) {
    if (!r.bag) return '';
    var days = r.bag.kg * 1000 / g, perDay = r.bag.price / days, h = '<div class="rr-panel"><div class="rr-ptitle">Reichweite und Kosten</div><div class="rr-stats">';
    if (!puppy) h += '<div class="rr-stat"><span>Ein ' + n(r.bag.kg, 1) + '-kg-Sack reicht</span><b>ca. ' + n(Math.floor(days)) + ' Tage</b></div>';
    return h + '<div class="rr-stat"><span>Kostet pro Tag</span><b>ca. ' + eur(perDay) + '</b></div><div class="rr-stat"><span>Kostet pro Monat</span><b>ca. ' + eur(perDay * 30) + '</b></div></div></div>';
  }
  function renderOut() {
    var out = $('out'), b = S.breed;
    if (!b) { out.innerHTML = ''; return; }
    var w = parseFloat(S.weight), fw = parseFloat(S.finalWeight), puppy = S.age === 'puppy';
    var need = $('need');
    if (!(w >= 1 && w <= 100)) { need.hidden = true; out.innerHTML = '<p class="rr-hint">Trag das Gewicht deines Hundes ein, dann zeigen wir dir die passenden Sorten.</p>'; return; }
    if (puppy && !(fw >= 1 && fw <= 100)) { need.hidden = true; out.innerHTML = '<p class="rr-hint">Trag noch das erwartete Endgewicht ein. Bei Rassen mit Gewichtsangabe ist es schon vorbelegt.</p>'; return; }
    var a = { age: S.age, weight: w, finalWeight: fw, neutered: S.neutered, activity: S.activity, shape: S.shape, ex: S.ex, wish: S.wish, allStages: S.allStages };
    var kcal = dailyKcal(a), m = mealCount(a), res = rank(RECIPES, a, b);
    need.hidden = false;
    need.innerHTML = '<b>Tagesbedarf: ca. ' + n(kcal) + ' kcal</b>' + (NEED_TXT[res.need] ? '<span>' + NEED_TXT[res.need] + '</span>' : '');
    if (!res.ok.length) {
      out.innerHTML = '<div class="rr-res"><p class="rr-warn" style="margin-top:0">Mit diesen Angaben passt keine unserer Sorten. Nimm einen Ausschluss oder Wunsch heraus, dann zeigen wir dir die nächstbeste Sorte.</p>' + excluded(res.out) + '</div>';
      return;
    }
    var top = recipeByKey(res.ok, S.pick) || res.ok[0], r = top.r, g = gramsPerDay(kcal, r.kcal);
    var h = '<div class="rr-res"><div class="rr-eyebrow">Dein Futter-Match' + (res.ok.length > 1 ? ' · ' + res.ok.length + ' von ' + (res.ok.length + res.out.length) + ' Sorten passen' : '') + '</div>';
    h += '<a class="rr-hero" data-rr-cta="' + esc(r.key) + '" href="' + esc(r.url) + '">' + (r.image ? '<img class="rr-pic" src="' + esc(r.image) + '" alt="' + esc(r.name) + '" width="112" height="112" loading="lazy">' : '') +
      '<span class="rr-hero-t"><span class="rr-name" style="display:block">MyPetClub ' + esc(r.name) + '</span>' + (r.line ? '<span class="rr-sub" style="display:block">' + esc(r.line) + '</span>' : '') + '<span class="rr-go">Sorte ansehen' + (r.price ? ' (ab ' + esc(r.price) + ')' : '') + ' &rsaquo;</span></span>' +
      ring(pct(res.ok, top), 76, 'Match') + '</a>';
    if (top.why.length) h += '<div class="rr-why">' + top.why.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</div>';
    h += '<div class="rr-panel"><div class="rr-ptitle">Tagesmenge</div><div class="rr-big"><b>ca. ' + n(g) + ' g</b> <span>pro Tag für ' + esc(b.handle ? b.name : 'deinen Hund') + '</span></div>' +
      '<div class="rr-sub">' + m + ' Mahlzeiten à ca. ' + n(g / m) + ' g · ' + n(kcal) + ' kcal am Tag</div></div>';
    h += stats(r, g, puppy) + '<div class="rr-panel"><div class="rr-ptitle">Nährwerte</div>' + nutLine(r) + '</div>';
    top.warn.forEach(function (x) { h += '<p class="rr-warn">' + esc(x) + '</p>'; });
    if (puppy) h += '<p class="rr-warn">Welpen wachsen schnell, der Bedarf ändert sich fast wöchentlich. Wiege alle ein bis zwei Wochen und passe die Menge an.</p>';
    if (r.est) h += '<p class="rr-warn">Für diese Sorte ist der Energiewert noch nicht hinterlegt, die Menge ist geschätzt.</p>';
    h += '<a class="rr-btn" data-rr-cta="' + esc(r.key) + '" href="' + esc(r.url) + '">MyPetClub ' + esc(r.name) + ' ansehen</a>';
    var alts = res.ok.filter(function (x) { return x.r.key !== r.key; }).slice(0, 4);
    if (alts.length) {
      h += '<div class="rr-alts"><div class="rr-eyebrow">Weitere passende Sorten</div>' + alts.map(function (x) {
        var ga = gramsPerDay(kcal, x.r.kcal), pd = x.r.bag ? x.r.bag.price / (x.r.bag.kg * 1000 / ga) : null;
        return '<div class="rr-alt" role="button" tabindex="0" data-pick="' + esc(x.r.key) + '">' + (x.r.image ? '<img class="rr-pic" src="' + esc(x.r.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<div class="rr-altt"><b>MyPetClub ' + esc(x.r.name) + '</b><span>' + esc(x.r.line) + '</span><span>' + n(ga) + ' g pro Tag' + (pd ? ' · ca. ' + eur(pd) + ' pro Tag' : '') + '</span></div>' + ring(pct(res.ok, x), 54) + '</div>';
      }).join('') + '</div>';
    }
    h += excluded(res.out);
    h += '<p class="rr-note">Richtwert für gesunde Hunde. Die Fütterungsempfehlung auf der Packung hat Vorrang, bei Krankheit oder Übergewicht sprich bitte mit deiner Tierarztpraxis. Leckerlis rechnest du von der Tagesration ab.</p>';
    var links = [];
    if (b.url) links.push('<a href="' + esc(b.url) + '">Futtermenge-Tabelle für ' + esc(b.name) + '</a>');
    if (b.handle) links.push('<a href="/pages/hunderassen/' + esc(b.handle) + '">Steckbrief ' + esc(b.name) + '</a>');
    if (links.length) h += '<p class="rr-links">' + links.join(' · ') + '</p>';
    out.innerHTML = h + '</div>';
    var sig = r.key + '|' + S.age;
    if (renderOut.sig !== sig) { renderOut.sig = sig; track('rr_result', { rr_recipe: r.key, rr_age: S.age, rr_breed: b.handle || 'mix', rr_ex: S.ex.join(','), rr_wish: S.wish.join(',') }); }
  }
  function nutShort(r) {
    var p = [];
    if (r.protein != null) p.push('Protein ' + String(r.protein).replace('.', ',') + ' %');
    if (r.fat != null) p.push('Fett ' + String(r.fat).replace('.', ',') + ' %');
    return p.length ? ' · ' + p.join(', ') : '';
  }
  function nutLine(r) {
    var p = [];
    if (r.protein != null) p.push('<span><b>' + String(r.protein).replace('.', ',') + ' %</b> Protein</span>');
    if (r.fat != null) p.push('<span><b>' + String(r.fat).replace('.', ',') + ' %</b> Fett</span>');
    if (r.fiber != null) p.push('<span><b>' + String(r.fiber).replace('.', ',') + ' %</b> Rohfaser</span>');
    p.push('<span><b>' + n(r.kcal) + '</b> kcal/kg</span>');
    return '<div class="rr-nut">' + p.join('') + '</div>';
  }
  function excluded(list) {
    if (!list.length) return '';
    return '<details class="rr-excl"><summary>Diese ' + list.length + ' Sorten passen nicht</summary><ul>' + list.map(function (x) {
      return '<li><b>MyPetClub ' + esc(x.r.name) + '</b>: ' + esc(x.reasons.join(', ')) + '</li>';
    }).join('') + '</ul></details>';
  }

  /* ===== RASSEN-SUCHE ===== */
  var matches = [], active = -1;
  function listEl() { return $('list'); }
  function closeList() { listEl().hidden = true; $('q').setAttribute('aria-expanded', 'false'); active = -1; }
  function showMatches(msg) {
    var ul = listEl();
    if (msg) ul.innerHTML = '<li class="rr-msg">' + esc(msg) + '</li>';
    else ul.innerHTML = matches.map(function (b, i) { return '<li role="option" id="rr-o' + i + '" data-i="' + i + '" aria-selected="' + (i === active ? 'true' : 'false') + '">' + esc(b.name) + '</li>'; }).join('');
    ul.hidden = false; $('q').setAttribute('aria-expanded', 'true');
  }
  function search() {
    var q = norm($('q').value);
    if (!BREEDS) { showMatches('Rassen werden geladen …'); return; }
    if (!q) { closeList(); return; }
    var starts = [], has = [];
    BREEDS.forEach(function (b) { var i = b.n.indexOf(q); if (i === 0) starts.push(b); else if (i > 0) has.push(b); });
    matches = starts.concat(has).slice(0, 8); active = -1;
    if (!matches.length) { showMatches('Keine Rasse gefunden. Nutze „Mischling oder Rasse nicht dabei“.'); return; }
    showMatches();
  }
  function choose(b) {
    S.breed = b;
    S.weight = meanWeight(b);
    S.finalWeight = S.weight;
    S.activity = b.bew != null && b.bew <= 2 ? 'low' : 'mid';
    S.pick = null;
    renderOut.sig = null;
    $('q').value = b.handle ? b.name : '';
    closeList(); syncForm(); renderOut();
    track('rr_breed', { rr_breed: b.handle || 'mix' });
  }

  /* ===== EREIGNISSE ===== */
  function pickAlt(el) {
    S.pick = el.getAttribute('data-pick'); renderOut(); track('rr_recipe_switch', { rr_recipe: S.pick });
    var o = $('out'); if (o && o.scrollIntoView) o.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  app.addEventListener('keydown', function (e) {
    var alt = e.target.closest && e.target.closest('.rr-alt');
    if (alt && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pickAlt(alt); }
  });
  app.addEventListener('focusin', function (e) {
    if (e.target.id !== 'rr-q' || BREEDS) return;
    loadBreeds().then(function () { if (document.activeElement === $('q')) search(); }, function () { showMatches('Die Rassenliste ist gerade nicht erreichbar. Nutze „Mischling oder Rasse nicht dabei“ und gib das Gewicht selbst ein.'); });
  });
  app.addEventListener('input', function (e) {
    var id = e.target.id;
    if (id === 'rr-q') {
      if (!BREEDS) { loadBreeds().then(search, function () { showMatches('Die Rassenliste ist gerade nicht erreichbar. Nutze „Mischling oder Rasse nicht dabei“.'); }); showMatches('Rassen werden geladen …'); return; }
      search();
    } else if (id === 'rr-w') { S.weight = e.target.value; S.pick = null; renderOut(); }
    else if (id === 'rr-fw') { S.finalWeight = e.target.value; S.pick = null; renderOut(); }
  });
  app.addEventListener('keydown', function (e) {
    if (e.target.id !== 'rr-q' || listEl().hidden || !matches.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      active = (active + (e.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length;
      [].forEach.call(listEl().children, function (li, i) { li.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
    } else if (e.key === 'Enter') { e.preventDefault(); choose(matches[active >= 0 ? active : 0]); }
    else if (e.key === 'Escape') closeList();
  });
  app.addEventListener('mousedown', function (e) {
    var li = e.target.closest && e.target.closest('li[data-i]');
    if (li) { e.preventDefault(); choose(matches[+li.getAttribute('data-i')]); }
  });
  document.addEventListener('click', function (e) { if (!app.contains(e.target) && $('list')) closeList(); });
  app.addEventListener('click', function (e) {
    var t = e.target.closest('button'), cta = e.target.closest('a[data-rr-cta]'), alt = e.target.closest('.rr-alt');
    if (cta) { track('rr_cta_click', { rr_recipe: cta.getAttribute('data-rr-cta') }); return; }
    if (alt) { pickAlt(alt); return; }
    if (!t) return;
    var act = t.getAttribute('data-act');
    if (act === 'mix') {
      choose({ handle: '', name: 'Mischling / andere Rasse', gmin: null, gmax: null, bew: null, fu: null, url: null, foto: null, allergiker: null, n: '' });
      $('w').focus();
    } else if (act === 'stages') {
      S.allStages = !S.allStages; S.pick = null; syncForm(); renderOut();
    } else if (t.getAttribute('data-pick')) {
      S.pick = t.getAttribute('data-pick'); renderOut(); track('rr_recipe_switch', { rr_recipe: S.pick });
      var top = $('out'); if (top && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (t.classList.contains('rr-opt')) {
      var k = t.getAttribute('data-k'), v = t.getAttribute('data-v');
      if (k === 'neutered') S.neutered = v === 'true';
      else if (k === 'ex' || k === 'wish') {
        var i = S[k].indexOf(v); if (i >= 0) S[k].splice(i, 1); else S[k].push(v);
        if (k === 'wish' && v === 'vegan' && i < 0) { /* fleischfrei schließt alle Fleisch-Ausschlüsse ein, nichts weiter nötig */ }
      } else {
        S[k] = v;
        if (k === 'age' && v === 'puppy' && S.finalWeight === '' && S.breed) S.finalWeight = meanWeight(S.breed);
      }
      S.pick = null;
      syncForm(); renderOut();
      track('rr_filter', { rr_ex: S.ex.join(','), rr_wish: S.wish.join(',') });
    }
  });

  build();
})();
